export enum UserSettingsTabs {
  PROFILE = 'profile',
  ORCID = 'orcid',
}

export enum OrcidScopes {
  READ_LIMITED = '/read-limited',
  ACTIVITIES_UPDATE = '/activities/update',
}
